<p>subscription-payment-step.component works!</p>
